export const P6_XML_DATE_FORMAT = 'YYYY/MM/DD HH:mm:ss';
